import { Component } from 'preact';
import style from './styles/RaffleCarouselController.scss';
import { showNextAction, showPreviousAction, setActiveIndexAction } from '../../actions/CarouselActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// eslint-disable-next-line react/prefer-stateless-function
class RaffleCarouselController extends Component {
	render({ raffles, activeIndex, showNextAction, showPreviousAction, setActiveIndexAction }) {
		return (
			<div className={style.controller}>
				<div className={`${style.controls} clearfix`}>
					<RaffleCarouselControllerButton {...{ className: `${style.button} ${style.previous}`, onClick: showPreviousAction }} />
					{raffles.map((raffle, index) => (
						<RaffleCarouselControllerDot {...{ raffle, index, active: index === activeIndex, onClick: setActiveIndexAction }} />
					))}
					<RaffleCarouselControllerButton {...{ className: `${style.button} ${style.next}`, onClick: showNextAction }} />
				</div>
			</div>
		);
	}
}

const RaffleCarouselControllerButton  = ({ className, onClick }) => (<div className={className} onClick={onClick} />);

class RaffleCarouselControllerDot extends Component {
	onClick = () => {
		this.props.onClick(this.props.index);
	};

	render({ active }) {
		const className = style.dot + (active ? ` ${style.active}` : '');
		return <div className={className} onClick={this.onClick} />;
	}
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({ showNextAction, showPreviousAction, setActiveIndexAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RaffleCarouselController);



// WEBPACK FOOTER //
// ./components/raffle/RaffleCarouselController.js